// Bilingual strings for Café 24
export const dict = {
    en: {
        app_name: "Café 24",
        tagline: "Coffee, conversation, community.",
        owner_login: "Owner Login",
        staff_login: "Staff PIN Login",
        email: "Email",
        password: "Password",
        login: "Sign in",
        logout: "Logout",
        pin: "PIN",
        enter_pin: "Enter your 4-digit PIN",
        wrong_pin: "Wrong PIN, try again",
        dashboard: "Dashboard",
        menu: "Menu",
        tables: "Tables",
        staff: "Staff",
        settings: "Settings",
        orders: "Orders",
        new_order: "New Order",
        cashier: "Cashier",
        waiter: "Waiter",
        manager: "Manager",
        kitchen: "Kitchen",
        owner: "Owner",
        driver: "Driver",
        driver_app: "Driver",
        available_orders: "Available",
        my_deliveries: "My Deliveries",
        pick_up: "Pick Up",
        mark_delivered: "Mark Delivered",
        out_for_delivery: "Out for Delivery",
        no_orders_yet: "No orders yet",
        ready_for_pickup: "Ready for pickup",
        picked_up_at: "Picked up at",
        delivered_at: "Delivered at",
        confirm_pickup: "Confirm Pickup",
        confirm_delivered_q: "Confirm delivered?",
        today: "Today",
        this_week: "This Week",
        this_month: "This Month",
        top_items: "Top items",
        busy_hours: "Busy hours",
        staff_perf: "Staff performance",
        sales: "Sales",
        revenue: "Revenue",
        qty: "Qty",
        orders_count: "Orders",
        pending: "Pending",
        confirmed: "Confirmed",
        delivered: "Delivered",
        paid: "Paid",
        rejected: "Rejected",
        on_hold: "On Hold",
        confirm_print: "Confirm & Print",
        reject: "Reject",
        hold: "Hold",
        deliver: "Mark Delivered",
        close_session: "Close & Pay",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        save: "Save",
        cancel: "Cancel",
        category: "Category",
        categories: "Categories",
        price: "Price",
        name_en: "Name (English)",
        name_ar: "Name (Arabic)",
        desc_en: "Description (English)",
        desc_ar: "Description (Arabic)",
        image_url: "Image URL",
        available: "Available",
        unavailable: "Unavailable",
        add_item: "Add Item",
        add_category: "Add Category",
        add_staff: "Add Staff",
        new_pin: "New 4-digit PIN",
        role: "Role",
        name: "Name",
        free: "Free",
        occupied: "Occupied",
        billing: "Billing",
        table: "Table",
        table_number: "Table number",
        select_table: "Select a table",
        send_to_cashier: "Send to Cashier",
        total: "Total",
        subtotal: "Subtotal",
        discount: "Discount",
        discount_type: "Discount Type",
        amount_sdg: "Amount (SDG)",
        percent: "Percent",
        percent_0_100: "Percent (0 – 100)",
        reason_optional: "Reason (optional)",
        add_discount: "Add Discount",
        edit_discount: "Edit Discount",
        remove_discount: "Remove Discount",
        discount_applied: "Discount applied",
        discount_removed: "Discount removed",
        apply: "Apply",
        cancel: "Cancel",
        ordering_channels: "Ordering Channels",
        ordering_channels_desc: "Turn each customer order channel on or off. Disabled channels won't appear on the public menu.",
        dine_in_desc: "Customers scan the QR and order from inside the cafe.",
        pickup_desc: "Customers order ahead and pick up from the counter.",
        delivery_desc: "Customers order to be delivered to their address.",
        date_range: "Date Range",
        single_day: "Single Day",
        from_date: "From",
        to_date: "To",
        select_date: "Select Date",
        today: "Today",
        last_7_days: "Last 7 days",
        last_30_days: "Last 30 days",
        deleted_items_log: "Deleted Items Log",
        no_deletions: "No deletions in this period.",
        set_delivery_fee: "Set Delivery Fee",
        invalid_amount: "Invalid amount",
        edit: "Edit",
        tax: "Tax",
        items: "Items",
        notes: "Notes",
        show_your_waiter: "Show your waiter to order",
        scan_to_browse: "Scan QR at your table to browse our menu",
        cafe_info: "Cafe Information",
        cafe_name: "Cafe name",
        address: "Address",
        phone: "Phone",
        tax_percent: "Tax %",
        logo_url: "Logo URL",
        receipt_footer: "Receipt footer",
        kitchen_printer: "Kitchen printer",
        currency: "Currency",
        print_receipt: "Print Receipt",
        kitchen_started_q: "Has the kitchen started preparing?",
        kitchen_yes_cancel: "Yes — Cancel only",
        kitchen_no_delete: "No — Delete item",
        added: "Added",
        removed: "Removed",
        order_sent: "Order sent to cashier",
        order_confirmed: "Order confirmed",
        order_rejected: "Order rejected",
        order_closed: "Session closed",
        switch_lang: "العربية",
        no_items: "No items yet",
        select_category: "Select a category",
        live_orders: "Live Orders",
        no_pending: "No pending orders",
        all_orders: "All Orders",
        order_no: "Order",
        waiter_name: "Waiter",
        cashier_name: "Cashier",
        time: "Time",
        actions: "Actions",
        view: "View",
        currently_active: "Currently active",
        free_tables: "Free tables",
        occupied_tables: "Occupied tables",
        pending_orders: "Pending orders",
        public_menu_link: "Public menu link",
        copy_link: "Copy link",
        copied: "Copied!",
        pay: "Pay",
        pay_now: "Pay & Close",
        no_active_order: "No active order on this table",
        add_to_order: "Add to Order",
        existing_items: "Already ordered",
        new_items: "New additions",
        items_added: "Items added to order",
        printer: "Thermal Printer",
        printer_connected: "Printer connected",
        printer_not_connected: "Printer not connected",
        connect_printer: "Connect USB Printer",
        disconnect_printer: "Disconnect",
        test_print: "Test Print",
        printer_test_sent: "Test print sent",
        printer_unsupported: "WebUSB is not supported. Use Google Chrome on Windows or Android.",
        reports: "Reports",
        daily_report: "Daily Report",
        date: "Date",
        days_back: "Days",
        no_data: "No data yet",
        export_csv: "Export CSV",
        order_now: "Order Now",
        cart: "Cart",
        your_order: "Your Order",
        customer_name: "Your Name",
        customer_phone: "Your Phone",
        order_type: "Order Type",
        dine_in: "Dine-in",
        pickup: "Takeaway",
        delivery: "Delivery",
        delivery_address: "Delivery Address",
        place_order: "Place Order",
        delivery_fee: "Delivery Fee",
        payment_method: "Payment Method",
        cash: "Cash",
        bankak: "Bankak",
        order_placed: "Order placed! Order #",
        from_waiter: "Waiter",
        from_online: "Online",
        confirm_delete: "Delete this?",
        loading: "Loading…",
        error: "Error",
        welcome_back: "Welcome back",
        select_role_login: "Select a role and tap your PIN",
        back: "Back",
        next: "Next",
        choose_table: "Choose table",
        no_categories: "No categories",
        no_menu_items: "No menu items",
        sales_last_7: "Sales (last 7 days)",
        orders_today: "Today's orders",
        revenue_today: "Today's revenue",
        revenue_month: "Monthly revenue",
        good_morning: "Good morning",
        good_afternoon: "Good afternoon",
        good_evening: "Good evening",
        quick_actions: "Quick actions",
        view_menu: "View Menu",
        manage_menu: "Manage Menu",
        manage_staff: "Manage Staff",
        manage_tables: "Manage Tables",
        view_orders: "Live Orders",
        open_settings: "Open Settings",
    },
    ar: {
        app_name: "كافيه ٢٤",
        tagline: "قهوة، حوار، مجتمع.",
        owner_login: "دخول المالك",
        staff_login: "دخول الموظفين بالـ PIN",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        login: "تسجيل الدخول",
        logout: "تسجيل الخروج",
        pin: "الرمز السري",
        enter_pin: "أدخل الرمز السري المكوّن من 4 أرقام",
        wrong_pin: "رمز غير صحيح، حاول مجدداً",
        dashboard: "لوحة التحكم",
        menu: "القائمة",
        tables: "الطاولات",
        staff: "الموظفون",
        settings: "الإعدادات",
        orders: "الطلبات",
        new_order: "طلب جديد",
        cashier: "كاشير",
        waiter: "ويتر",
        manager: "مدير",
        kitchen: "مطبخ",
        owner: "المالك",
        driver: "سائق",
        driver_app: "السائق",
        available_orders: "الطلبات المتاحة",
        my_deliveries: "طلباتي",
        pick_up: "استلام",
        mark_delivered: "تم التوصيل",
        out_for_delivery: "قيد التوصيل",
        no_orders_yet: "لا توجد طلبات",
        ready_for_pickup: "جاهز للاستلام",
        picked_up_at: "وقت الاستلام",
        delivered_at: "وقت التوصيل",
        confirm_pickup: "تأكيد الاستلام",
        confirm_delivered_q: "تأكيد التوصيل؟",
        today: "اليوم",
        this_week: "هذا الأسبوع",
        this_month: "هذا الشهر",
        top_items: "الأصناف الأكثر مبيعاً",
        busy_hours: "أوقات الذروة",
        staff_perf: "أداء الموظفين",
        sales: "المبيعات",
        revenue: "الإيرادات",
        qty: "الكمية",
        orders_count: "الطلبات",
        pending: "بانتظار",
        confirmed: "مؤكدة",
        delivered: "مُسلّمة",
        paid: "مدفوعة",
        rejected: "مرفوضة",
        on_hold: "معلقة",
        confirm_print: "تأكيد وطباعة",
        reject: "رفض",
        hold: "تعليق",
        deliver: "تم التسليم",
        close_session: "إغلاق ودفع",
        delete: "حذف",
        edit: "تعديل",
        add: "إضافة",
        save: "حفظ",
        cancel: "إلغاء",
        category: "الفئة",
        categories: "الفئات",
        price: "السعر",
        name_en: "الاسم (إنجليزي)",
        name_ar: "الاسم (عربي)",
        desc_en: "الوصف (إنجليزي)",
        desc_ar: "الوصف (عربي)",
        image_url: "رابط الصورة",
        available: "متوفر",
        unavailable: "غير متوفر",
        add_item: "إضافة صنف",
        add_category: "إضافة فئة",
        add_staff: "إضافة موظف",
        new_pin: "رمز PIN جديد من 4 أرقام",
        role: "الدور",
        name: "الاسم",
        free: "متاحة",
        occupied: "مشغولة",
        billing: "محاسبة",
        table: "طاولة",
        table_number: "رقم الطاولة",
        select_table: "اختر الطاولة",
        send_to_cashier: "إرسال للكاشير",
        total: "الإجمالي",
        subtotal: "الفرعي",
        discount: "خصم",
        discount_type: "نوع الخصم",
        amount_sdg: "مبلغ (ج.س)",
        percent: "نسبة %",
        percent_0_100: "النسبة (0 – 100)",
        reason_optional: "السبب (اختياري)",
        add_discount: "إضافة خصم",
        edit_discount: "تعديل الخصم",
        remove_discount: "إزالة الخصم",
        discount_applied: "تم تطبيق الخصم",
        discount_removed: "تم إزالة الخصم",
        apply: "تطبيق",
        cancel: "إلغاء",
        ordering_channels: "قنوات الطلب",
        ordering_channels_desc: "فعّل أو أوقف كل قناة طلب من الزبائن. القنوات المعطّلة لن تظهر في قائمة الزبون.",
        dine_in_desc: "الزبائن يطلبون داخل الكافيه عن طريق مسح QR.",
        pickup_desc: "الزبائن يطلبون مسبقاً ويستلمون من الكاونتر.",
        delivery_desc: "الزبائن يطلبون توصيل إلى عنوانهم.",
        date_range: "نطاق التاريخ",
        single_day: "يوم محدد",
        from_date: "من",
        to_date: "إلى",
        select_date: "اختر التاريخ",
        today: "اليوم",
        last_7_days: "آخر 7 أيام",
        last_30_days: "آخر 30 يوم",
        deleted_items_log: "سجل الأصناف المحذوفة",
        no_deletions: "لا توجد عمليات حذف في هذه الفترة.",
        set_delivery_fee: "تحديد رسوم التوصيل",
        invalid_amount: "مبلغ غير صحيح",
        edit: "تعديل",
        tax: "الضريبة",
        items: "الأصناف",
        notes: "ملاحظات",
        show_your_waiter: "تواصل مع الويتر للطلب",
        scan_to_browse: "امسح QR على الطاولة لتصفح قائمتنا",
        cafe_info: "بيانات الكافيه",
        cafe_name: "اسم الكافيه",
        address: "العنوان",
        phone: "الهاتف",
        tax_percent: "نسبة الضريبة %",
        logo_url: "رابط الشعار",
        receipt_footer: "تذييل الفاتورة",
        kitchen_printer: "طابعة المطبخ",
        currency: "العملة",
        print_receipt: "طباعة الفاتورة",
        kitchen_started_q: "هل بدأ المطبخ بالتحضير؟",
        kitchen_yes_cancel: "نعم — إلغاء فقط",
        kitchen_no_delete: "لا — حذف الصنف",
        added: "تمت الإضافة",
        removed: "تمت الإزالة",
        order_sent: "تم إرسال الطلب للكاشير",
        order_confirmed: "تم تأكيد الطلب",
        order_rejected: "تم رفض الطلب",
        order_closed: "تم إغلاق الجلسة",
        switch_lang: "English",
        no_items: "لا توجد أصناف",
        select_category: "اختر فئة",
        live_orders: "الطلبات المباشرة",
        no_pending: "لا توجد طلبات معلقة",
        all_orders: "كل الطلبات",
        order_no: "طلب",
        waiter_name: "الويتر",
        cashier_name: "الكاشير",
        time: "الوقت",
        actions: "إجراءات",
        view: "عرض",
        currently_active: "نشط حالياً",
        free_tables: "طاولات متاحة",
        occupied_tables: "طاولات مشغولة",
        pending_orders: "طلبات معلقة",
        public_menu_link: "رابط القائمة العامة",
        copy_link: "نسخ الرابط",
        copied: "تم النسخ!",
        pay: "دفع",
        pay_now: "دفع وإغلاق",
        no_active_order: "لا يوجد طلب نشط على هذه الطاولة",
        add_to_order: "إضافة للطلب",
        existing_items: "الأصناف الحالية",
        new_items: "الإضافات الجديدة",
        items_added: "تمت إضافة الأصناف للطلب",
        printer: "الطابعة الحرارية",
        printer_connected: "الطابعة متصلة",
        printer_not_connected: "الطابعة غير متصلة",
        connect_printer: "ربط الطابعة USB",
        disconnect_printer: "فصل الطابعة",
        test_print: "طباعة تجريبية",
        printer_test_sent: "تم إرسال الطباعة التجريبية",
        printer_unsupported: "WebUSB غير مدعوم. استخدم متصفح Chrome على Windows أو Android.",
        reports: "التقارير",
        daily_report: "التقرير اليومي",
        date: "التاريخ",
        days_back: "عدد الأيام",
        no_data: "لا توجد بيانات حتى الآن",
        export_csv: "تصدير CSV",
        order_now: "اطلب الآن",
        cart: "السلة",
        your_order: "طلبك",
        customer_name: "الاسم",
        customer_phone: "رقم الهاتف",
        order_type: "نوع الطلب",
        dine_in: "داخل الكافيه",
        pickup: "سفري",
        delivery: "توصيل",
        delivery_address: "عنوان التوصيل",
        place_order: "تأكيد الطلب",
        delivery_fee: "رسوم التوصيل",
        payment_method: "طريقة الدفع",
        cash: "كاش",
        bankak: "بنكك",
        order_placed: "تم استلام طلبك! رقم الطلب: ",
        from_waiter: "ويتر",
        from_online: "أونلاين",
        confirm_delete: "هل تريد الحذف؟",
        loading: "جاري التحميل…",
        error: "خطأ",
        welcome_back: "أهلاً بعودتك",
        select_role_login: "اختر دورك وأدخل الرمز",
        back: "رجوع",
        next: "التالي",
        choose_table: "اختر الطاولة",
        no_categories: "لا توجد فئات",
        no_menu_items: "لا توجد أصناف",
        sales_last_7: "المبيعات (آخر 7 أيام)",
        orders_today: "طلبات اليوم",
        revenue_today: "إيرادات اليوم",
        revenue_month: "إيرادات الشهر",
        good_morning: "صباح الخير",
        good_afternoon: "مساء الخير",
        good_evening: "مساء الخير",
        quick_actions: "إجراءات سريعة",
        view_menu: "عرض القائمة",
        manage_menu: "إدارة القائمة",
        manage_staff: "إدارة الموظفين",
        manage_tables: "إدارة الطاولات",
        view_orders: "الطلبات المباشرة",
        open_settings: "فتح الإعدادات",
    },
};

export const t = (lang, key) => dict[lang]?.[key] ?? dict.en[key] ?? key;
